<template>
  <AppView
    padd-bottom
  >

    <template v-slot:top-app-view>
      <transition name="fade" mode="out-in" appear>
        <CompanyHeader :company="company" :loading="loadingCompany" />
      </transition>
    </template>

    <transition name="fade" mode="out-in" appear>

      <div v-if="errorCompany" class="tw-mt-12" key="errmsg">
        <p class="tw-py-12 tw-text-base tw-text-center" v-html="errorCompany"></p>
      </div>

      <div v-else-if="loadingCompany" class="tw-mt-12" key="lodng">
        <p class="tw-py-12 tw-text-base tw-text-center">Loading...</p>
      </div>

      <div v-else key="bdy">
        <portal to="modal-body" key="mdl">
          <EditModule
            :class="['tw-p-6']"
            :company-program="activeCompanyProgram"
            :module-id="editingModuleId"
            @created-success="closeModal(); getProgramModules();"
          />
        </portal>

        <transition name="fade" mode="out-in" appear>

          <div class="app-view-grid px-body">
            <div class="app-view-grid__col-74">

              <div class="tw-flex tw-items-center tw-mb-4">
                <UserPhoto
                  :photo="activeCompanyProgram.logo"
                  :user-name="{
                    name: activeCompanyProgram.name,
                  }"
                  logo
                  photo-size="tw-h-10 tw-w-10"
                  :class="[
                    'tw-rounded-10--force --force-children tw-bg-app-white-87 tw-mx-2',
                    { 'tw-shadow-app-sm': !(activeCompanyProgram.logo || '').length }
                  ]"
                />

                <p class="tw-font-bold">
                  {{ activeCompanyProgram.name }} Mentorship Program
                </p>
              </div>

              <!-- <div class="tw-p-5 tw-rounded-10 tw-bg-gray-600 tw-flex tw-items-center tw-justify-between">
                <p class="tw-text-lg tw-text-white">Customize Modules Badges</p>
                <BaseButton
                  text="Customize"
                  :to="{ name: 'editCompanyProgramModulesBadges', params: { id, programId } }"
                  class="tw-bg-white tw-border-none tw-text-gray-600"
                />
              </div> -->

              <div class="tw-p-5 tw-rounded-10 tw-bg-gray-600 tw-flex tw-items-center tw-justify-between">
                <p class="tw-text-lg tw-text-white">Customize Tasks Badges</p>
                <BaseButton
                  text="Customize"
                  :to="{ name: 'editCompanyProgramTasksBadges', params: { id, programId } }"
                  class="tw-bg-white tw-border-none tw-text-gray-600"
                />
              </div>

              <template>
                <div class="tw-flex tw-items-center tw-pt-10 tw-pb-4">
                  <img
                    data-src="/img/edit-goals.png"
                    src="/img/edit-goals.png"
                    style="width: 80px; height: 80px;"
                    class="tw-object-cover tw-block tw-mr-8"
                    async
                  >
                  <h3 class="font-title tw-text-xl tw-tracking-wider">
                    Modules
                  </h3>

                  <div class="tw-ml-auto">
                    <BaseButton
                      text="Add"
                      title="Create a Module"
                      @click="createProgramModule"
                    />
                  </div>
                </div>
                <div class="tw-border-t tw-border-app-black-11 tw-mb-16"></div>
                <div></div>
              </template>

              <!--  MODULES -->
              <template>

                <ViewMore
                  class="tw-flex tw-flex-wrap stacked-grid stacked-grid--stack-three lg:stacked-grid--stack-three"
                  :list="programModules"
                  :limit="12"
                  v-slot="{ item: programModule }"
                >
                  <div class="info-card tw-group tw-shadow-app tw-relative tw-flex tw-flex-col tw-justify-between">
                    <div>
                      <h4 class="tw-leading-tight tw-font-medium opacity-87 tw-text-base tw-px-2 tw-py-4 tw-break-words">
                        {{ programModule.goal }}
                        <template v-if="moduleIsCurrentlyRunning(programModule)">
                          <br />
                          <span class="tw-uppercase tw-px-2 tw-text-xs tw-rounded-10 tw-bg-app-primary-orange">
                            Current Active
                          </span>
                        </template>
                      </h4>
                      <h6 class="tw-text-xs leading-15 tw-px-2 tw-mb-4 opacity-87">
                        <span>
                          Start date: {{ programModule.start | toJsDate | moment('MMM Do YYYY') }}
                        </span>
                        <br />
                        <span>
                          Duration: {{ programModule.duration }} days
                        </span>
                      </h6>
                    </div>

                    <h6 class="opacity-31 tw-text-xs leading-15 tw-overflow-hidden tw-m-2 tw-mt-0 tw-self-start" style="max-height: 150px" v-html="programModule.description" >
                    </h6>
                    <div class="tw-flex tw-items-end tw-mt-3 tw-justify-between">
                      <div class="tw-flex-initial">
                        <button
                          class="group-hover:tw-opacity-100 opacity-18 tw-shadow-app transition-fast info-card__action tw-rounded-3 tw-fill-current tw-px-2 tw-py-1 tw-ml-2 tw-mb-2 tw-inline-block transition-fast tw-bg-app-deep-blue-11"
                          @click.prevent="editModule(programModule)"
                        >
                          <span class="tw-px-2 opacity-78 tw-inline-block tw-text-sm leading-17 tw-uppercase">Edit</span>
                        </button>
                      </div>
                      <div class="tw-self-end tw-inline-block">
                        <BaseButton
                          v-if="Number(programModule.status) !== 2"
                          text="Deactivate"
                          title="Deactivate"
                          class="group-hover:tw-opacity-100 opacity-18 transition-fast info-card__action tw-mr-2 tw-mb-2"
                          :confirm="true"
                          confirm-message="Are you sure you want to deactivate this module?"
                          @click="deactivateModule(programModule.id)"
                        />
                        <span v-if="Number(programModule.status) === 2" class="tw-text-xs tw-text-app-primary-orange tw-mr-2 tw-mb-2">
                          Deactivated
                        </span>
                      </div>
                    </div>
                  </div>
                </ViewMore>

                <div></div>

              </template>

            </div>
          </div>

        </transition>

      </div>

    </transition>

  </AppView>
</template>

<script>
// import _sortBy from 'lodash/sortBy';
// import _reverse from 'lodash/reverse';

import EditModule from '@/views/Companies/Company/_partials/EditModule.vue';
import ViewMore from '@/components/ViewMore.vue';
import CompanyHeader from '@/views/Companies/Company/_partials/CompanyHeader.vue';
import UserPhoto from '@/components/UserPhoto.vue';

import companyMixin from '@/mixins/company';
import companyProgramMixin from '@/mixins/companyProgram';

export default {
  name: 'EditCompanyModulesView',
  components: {
    EditModule,
    ViewMore,
    UserPhoto,
    CompanyHeader,
  },
  mixins: [companyMixin, companyProgramMixin],
  props: ['id', 'programId'],
  data() {
    return {
      loadingModules: true,
      errorModules: undefined,
      programModules: [],
      editingModuleId: undefined,
    };
  },
  methods: {
    async getProgramModules() {
      this.loadingModules = true;
      this.errorModules = undefined;

      const formData = {
        progid: this.activeCompanyProgram.id,
      };

      const modules = await this.$store.dispatch('getProgramModules', formData);

      if (!modules) {
        this.$toasted.global.appError({ errorMessage: 'Could not fetch program modules' });
        this.loadingModules = false;
        this.errorModules = 'Could not fetch program modules';
        return;
      }

      await this.$nextTick();

      // how to sort by timeframe
      this.programModules = modules;
      this.loadingModules = false;
    },

    async createProgramModule() {
      this.editingModuleId = undefined;

      await this.$nextTick();

      // open modal
      this.$store.commit('openModal', [true, 'modal']);
    },

    async editModule(programModule) {
      this.editingModuleId = programModule.id;

      await this.$nextTick();

      // open modal
      this.$store.commit('openModal', [true, 'modal']);
    },

    async deactivateModule(goalid) {
      const response = await this.$store.dispatch('deactivateProgramModule', goalid);

      await this.$nextTick();

      if (response) {
        this.$toasted.success('Module deactivated successfully', {
          duration: 3500,
          position: 'top-right',
        });

        await this.getProgramModules();
      } else {
        this.$toasted.global.appError({ errorMessage: 'Failed to deactivate module' });
      }
    },

    moduleIsCurrentlyRunning(programModule) {
      const today = this.$moment(new Date());
      const startDate = this.$moment(programModule.start);
      const endDate = this.$moment(programModule.start).add(Number(programModule.duration), 'days');

      // Check if today is between startDate and endDate (inclusive)
      if (today.isSameOrAfter(startDate) && today.isSameOrBefore(endDate)) {
        return true;
      }

      return false;
    },
  },
  async created() {
    // get company
    await Promise.all([
      this.getCompany(),
    ]);

    await this.$nextTick();

    // assert user company permissions
    if (!this.hasPermission) {
      this.$router.push({
        name: 'app',
      });

      return false;
    }

    await this.getCompanyProgram();
    await this.$nextTick();

    if (!this.hasProgramPermission) {
      this.$router.push({
        name: 'app',
      });

      return false;
    }

    await this.getProgramModules();

    await this.$nextTick();
    await this.$nextTick();

    return true;
  },
};
</script>

<style>

</style>
